/**
 * Blog Analytics Hook - Stub (tracking removed for privacy)
 * All external tracking has been removed for DSGVO compliance.
 */

import { useLocation } from 'react-router-dom';

interface BlogAnalyticsConfig {
  trackBlogViews?: boolean;
  trackTagPerformance?: boolean;
  trackScrollDepth?: boolean;
}

interface BlogAnalyticsData {
  slug?: string;
  category?: string;
  tags?: string[];
  readingTime?: number;
}

export const useBlogAnalytics = (
  _config: BlogAnalyticsConfig = {},
  _data?: BlogAnalyticsData
) => {
  // No-op functions - tracking removed for privacy compliance
  const trackTagClick = (_tag: string) => {};
  const trackRelatedArticleClick = (_targetSlug: string, _currentSlug?: string) => {};
  const trackLocalSearch = (_query: string, _results: number) => {};

  return {
    trackTagClick,
    trackRelatedArticleClick,
    trackLocalSearch
  };
};
